module.exports = __webpack_public_path__ + "img/panel6.ef41bc9f.jpg";